module.exports = __webpack_public_path__ + "img/roadmap-phase-1-cell-1-icon.ddd5f183.svg";